mapboxgl.accessToken =
    "pk.eyJ1IjoiZHVvc3R1ZGlvIiwiYSI6ImNsbHI0dzNlZzBpeGcza28wN3poZ2kyaDkifQ.8jcIDMyngTd6XLhNt5jOEA";
// Calculate padding based on sidebar width and viewport
const getSidebarPadding = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        return { left: 0, top: 0, right: 0, bottom: 0 }; // No offset needed on mobile
    } else {
        // On desktop, sidebar takes 35% + gaps, so offset center point accordingly
        const sidebarWidthPercent = 35;
        const paddingLeft = Math.floor(
            (window.innerWidth * sidebarWidthPercent) / 100,
        );
        return { left: paddingLeft, top: 0, right: 0, bottom: 0 };
    }
};

const map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/dark-v11",
    center: [MAP_JSON.centerPoint.longitude, MAP_JSON.centerPoint.latitude],
    zoom: window.innerWidth > 1080 ? 14.5 : 14.5,
});
map.addControl(new mapboxgl.NavigationControl());
map.scrollZoom.disable();

// Handle window resize to update padding
window.addEventListener("resize", () => {
    // Debounce resize events
    clearTimeout(window.mapResizeTimeout);
    window.mapResizeTimeout = setTimeout(() => {
        map.resize(); // Ensure map resizes properly
    }, 250);
});
var locations = [
    {
        category: "Main",
        name: "Center",
        lat: MAP_JSON.centerPoint.latitude,
        lon: MAP_JSON.centerPoint.longitude,
        address: MAP_JSON.centerPoint.address,
        url: MAP_JSON.centerPoint.googleMapUrl,
    },
    ...MAP_JSON.mapPoints.map((point) => ({
        category: point.category.split(" ")[0],
        name: point.title.replace(/['"]/g, ""),
        lat: point.latitude,
        lon: point.longitude,
        address: point.address,
        url: point.googleMapUrl,
    })),
];
const mainLat = MAP_JSON.centerPoint.latitude;
const mainLon = MAP_JSON.centerPoint.longitude;
function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
        0.5 -
        Math.cos(dLat) / 2 +
        (Math.cos((lat1 * Math.PI) / 180) *
            Math.cos((lat2 * Math.PI) / 180) *
            (1 - Math.cos(dLon))) /
            2;
    return R * 2 * Math.asin(Math.sqrt(a));
}
const sortedData = locations.sort((a, b) => {
    const distanceA = calculateDistance(mainLat, mainLon, a.lat, a.lon);
    const distanceB = calculateDistance(mainLat, mainLon, b.lat, b.lon);
    return distanceA - distanceB;
});

document.querySelectorAll(".map-button").forEach((button) => {
    button.addEventListener("click", () => {
        const category = button.dataset.category;
        filterLocations(category);
    });
});

const renderMapItems = (_locations) => {
    document.getElementById("map-items").innerHTML = _locations
        .map(
            (el, id) =>
                `<div class="map-button-container"><button class='clean-button map-item-button' data-name="${el.name.replace(
                    "'",
                    "\\'",
                )}" data-id="${id + 1}"><div class="circle-list-item">${id + 1}</div> ${
                    el.name
                }</button></div>`,
        )
        .join(" ");

    // Add event listeners to the newly created buttons
    document.querySelectorAll(".map-item-button").forEach((button) => {
        button.addEventListener("click", () => {
            highlightItem(button.dataset.name, parseInt(button.dataset.id));
        });
    });
};

let filter = "";
const _locations = locations.filter(
    (location) =>
        location.category !== "Main" &&
        (!filter || location.category === filter),
);
map.on("load", function () {
    // Apply initial padding to offset center point for sidebar
    const initialPadding = getSidebarPadding();
    if (initialPadding.left > 0) {
        map.easeTo({
            center: [
                MAP_JSON.centerPoint.longitude,
                MAP_JSON.centerPoint.latitude,
            ],
            padding: initialPadding,
            duration: 0, // Instant application on load
        });
    }
    map.loadImage(MAP_JSON.pins.default, (error, image) => {
        if (error) {
            console.log(error);
            throw error;
        }
        map.addImage("pin", image);

        map.addSource("locations", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: createFeatures(_locations),
            },
        });
        map.addSource("locations-number", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: createFeatures(_locations),
            },
        });

        renderMapItems(_locations);
        const locationsLoaded = map.getLayer("location-highlighted")
            ? true
            : false;

        map.addLayer(
            {
                id: "locations",
                source: "locations",
                type: "symbol",
                layout: {
                    "icon-image": "pin",
                    "icon-size": 0.8,
                    "text-field": ["get", "label"],
                    "text-font": ["Arial Unicode MS Bold"],
                    "text-offset": [0, 0],
                    "text-size": 12,
                    // "text-allow-overlap": true,
                    // "text-ignore-placement": true,
                    // "icon-allow-overlap": true,
                    // "icon-ignore-placement": true,
                },
                paint: {
                    "text-color": "#000000",
                },
            },
            locationsLoaded ? "location-highlighted" : undefined,
        );

        map.on("mouseenter", "locations", () => {
            map.getCanvas().style.cursor = "pointer";
        });

        map.on("mouseleave", "locations", () => {
            map.getCanvas().style.cursor = "";
        });

        map.on("click", "locations", (e) => {
            if (!e.features[0]) return;
            highlightItem(
                e.features[0].properties.name,
                e.features[0].properties.label,
            );
        });
    });

    map.loadImage(MAP_JSON.pins.highlighted, (error, image) => {
        if (error) return;
        map.addImage("pin-highlighted", image);

        map.addSource("location-highlighted", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: [],
            },
        });
        map.addSource("location-highlighted-number", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: [],
            },
        });

        map.addLayer({
            id: "location-highlighted",
            source: "location-highlighted",
            type: "symbol",

            layout: {
                "icon-image": "pin-highlighted",
                "icon-size": 0.9,
                "text-field": ["get", "label"],
                "text-font": ["Arial Unicode MS Bold"],
                "text-offset": [0, 0],
                "text-size": 12,
                "text-allow-overlap": true,
                "text-ignore-placement": true,
                "icon-allow-overlap": true,
                "icon-ignore-placement": true,
            },
            paint: {
                "text-color": "#000000",
            },
        });
    });

    map.loadImage(SETTINGS_JSON.favicon, (error, image) => {
        if (error) return;
        map.addImage("Main", image);

        const main = [
            locations.find((location) => {
                return location.category === "Main";
            }),
        ];

        map.addSource("main", {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: createFeatures(main),
            },
        });

        map.addLayer({
            id: "main",
            source: "main",
            type: "symbol",
            layout: {
                "icon-image": "Main",
                "icon-size": 0.9,
                "text-allow-overlap": true,
                "text-ignore-placement": true,
                "icon-allow-overlap": true,
                "icon-ignore-placement": true,
            },
        });
    });
});

const filterLocations = (type) => {
    unhighlightItem();
    const _locations = locations.filter((location) => {
        if (type === "All") return location.category !== "Main";
        return location.category === type;
    });
    map.getSource("locations").setData({
        type: "FeatureCollection",
        features: createFeatures(_locations),
    });
    map.getSource("locations-number").setData({
        type: "FeatureCollection",
        features: createFeatures(_locations),
    });
    document.querySelectorAll(".map-button").forEach((button) => {
        button.classList.remove("map-button-active");
    });

    document
        .getElementById(`${type.toLowerCase()}-map-button`)
        .classList.add("map-button-active");

    renderMapItems(_locations);

    adjustMapBoundsToFeatures(map, "locations");

    document.querySelectorAll(".map-button-container").forEach((item) => {
        item.classList.remove("active");
    });
};

function adjustMapBoundsToFeatures(map, sourceId) {
    const sourceData = map.getSource(sourceId)._data;

    if (!sourceData || !sourceData.features.length) {
        console.log("No features to adjust bounds to.");
        return;
    }

    let bounds = new mapboxgl.LngLatBounds();

    sourceData.features.forEach((feature) => {
        const coords = feature.geometry.coordinates;

        bounds.extend(coords);
    });

    map.fitBounds(bounds, {
        duration: 1000,
        padding: getSidebarPadding(),
    });
}

const createFeatures = (locations, label) => {
    return locations.map((location, id) => {
        return {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [location.lon, location.lat],
            },
            properties: {
                label: label ? label.toString() : `${id + 1}`,
                name: location.name,
                category: location.category,
            },
        };
    });
};

const highlightItem = (id, label) => {
    const highlighted = map.getSource("location-highlighted");
    const text = map.getSource("location-highlighted-number");

    if (!highlighted || !text) return;
    else {
        const location = locations.find((loc) => loc.name === id);
        if (!location) return;
        else {
            map.getSource("location-highlighted").setData({
                type: "FeatureCollection",
                features: createFeatures([location], label),
            });
            map.getSource("location-highlighted-number").setData({
                type: "FeatureCollection",
                features: createFeatures([location], label),
            });
            const popup = document.getElementById("map-popup");
            const title = document.getElementById("map-popup-title");
            const address = document.getElementById("map-popup-address");
            const url = document.getElementById("map-popup-url");

            popup.style.display = "block";
            title.textContent = location.name;
            address.textContent = location.address;
            url.href = location.url;

            map.fitBounds(
                new mapboxgl.LngLatBounds(
                    [location.lon, location.lat],
                    [location.lon, location.lat],
                ),
                {
                    maxZoom: 14.5,
                    padding: getSidebarPadding(),
                },
            );
        }
    }

    document.querySelectorAll(".map-button-container").forEach((item) => {
        item.classList.remove("active");
    });
    document
        .querySelectorAll(".map-button-container")
        [label - 1].classList.add("active");
};

const unhighlightItem = () => {
    document.getElementById("map-popup").style.display = "none";
    map.getSource("location-highlighted").setData({
        type: "FeatureCollection",
        features: [],
    });
    map.getSource("location-highlighted-number").setData({
        type: "FeatureCollection",
        features: [],
    });
};
